import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import axios from '../api/axiosConfig';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Pagination from '../components/Pagination';
import HistorialNovedadesTransitoModal from '../components/HistorialNovedadesTransitoModal';
import './Profiles.css'; // Reutilizamos estilos de perfiles o creamos Transitos.css

const Transitos = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [transitos, setTransitos] = useState([]);
  const [zonas, setZonas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // Estado para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  
  // Modales
  const [showModal, setShowModal] = useState(false);
  const [editingTransito, setEditingTransito] = useState(null);
  const [showNovedadModal, setShowNovedadModal] = useState(false);
  const [transitoForNovedad, setTransitoForNovedad] = useState(null);
  const [novedadText, setNovedadText] = useState('');
  const [showHistorialModal, setShowHistorialModal] = useState(false);
  const [selectedTransitoForHistorial, setSelectedTransitoForHistorial] = useState(null);
  
  // Datos del formulario
  const [formData, setFormData] = useState({
    name: '',
    nit: '',
    address: '',
    phone: '',
    status: 'activo',
    plate_assignment_mode: 'automatico',
    zona_id: '',
    novedad_actual: ''
  });

  // Verificar superadmin o admin
  useEffect(() => {
    if (user?.role !== 'superadmin' && user?.role !== 'admin') {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  useEffect(() => {
    fetchTransitos();
    fetchZonas();
  }, []);

  const fetchZonas = async () => {
    try {
      const res = await axios.get('/api/zonas');
      setZonas(res.data);
    } catch (err) {
      console.error('Error al cargar zonas:', err);
    }
  };

  const fetchTransitos = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/transitos');
      setTransitos(res.data);
      setError('');
    } catch (err) {
      setError('Error al cargar tránsitos');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (transito = null) => {
    if (transito) {
      setEditingTransito(transito);
      setFormData({
        name: transito.name,
        nit: transito.nit || '',
        address: transito.address || '',
        phone: transito.phone || '',
        status: transito.status,
        plate_assignment_mode: transito.plate_assignment_mode || 'automatico',
        zona_id: transito.zona_id || '',
        novedad_actual: transito.novedad_actual || ''
      });
    } else {
      setEditingTransito(null);
      setFormData({
        name: '',
        nit: '',
        address: '',
        phone: '',
        status: 'activo',
        plate_assignment_mode: 'automatico',
        zona_id: '',
        novedad_actual: ''
      });
    }
    setShowModal(true);
  };

  const handleToggleStatus = async (transito) => {
    try {
      const newStatus = transito.status === 'activo' ? 'inactivo' : 'activo';
      await axios.put(`/api/transitos/${transito.id}`, { ...transito, status: newStatus });
      fetchTransitos();
    } catch (err) {
      setError(err.response?.data?.message || 'Error al cambiar estado');
    }
  };

  const handleOpenNovedadModal = (transito) => {
    setTransitoForNovedad(transito);
    setNovedadText(transito.novedad_actual || '');
    setShowNovedadModal(true);
  };

  const handleSaveNovedad = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/api/transitos/${transitoForNovedad.id}`, { ...transitoForNovedad, novedad_actual: novedadText });
      fetchTransitos();
      setShowNovedadModal(false);
    } catch (err) {
      setError('Error al guardar novedad');
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editingTransito) {
        await axios.put(`/api/transitos/${editingTransito.id}`, formData);
      } else {
        await axios.post('/api/transitos', formData);
      }
      fetchTransitos();
      setShowModal(false);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al guardar tránsito');
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Lógica de paginación
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = transitos.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (items) => {
    setItemsPerPage(items);
    setCurrentPage(1);
  };

  return (
    <div className="app-layout">
      <Sidebar />

      <div className="main-content">
        <Navbar title="🏢 Gestión de Tránsitos (Empresas)" />

        <div className="page-content">
          {error && <div className="error-banner">{error}</div>}

          <div className="page-header">
            <div className="header-title">
              <h2>Tránsitos Registrados</h2>
              <p className="subtitle">Organismos y empresas que operan en el sistema</p>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button 
                onClick={() => {
                  setSelectedTransitoForHistorial(null);
                  setShowHistorialModal(true);
                }} 
                className="btn-action"
                style={{
                  background: '#0284c7',
                  color: '#ffffff',
                  border: 'none',
                  padding: '10px 16px',
                  borderRadius: '8px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                📜 Bitácora de Novedades
              </button>
              {user?.role === 'superadmin' && (
                <button onClick={() => handleOpenModal()} className="btn-primary">
                  ➕ Nuevo Tránsito
                </button>
              )}
            </div>
          </div>

          {loading ? (
            <p className="loading">Cargando tránsitos...</p>
          ) : (
            <div className="table-wrapper">
              <div className="table-responsive">
                <table className="users-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>NIT</th>
                    <th>Dirección</th>
                    <th>Zona</th>
                    <th>Asignación Placa</th>
                    <th>Estado</th>
                    <th>Novedad</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map(t => (
                    <tr key={t.id}>
                      <td className="user-name">{t.name}</td>
                      <td>{t.nit}</td>
                      <td>{t.address}</td>
                      <td>
                        <span className="profile-badge" style={{ backgroundColor: '#e2e8f0', color: '#1e293b' }}>
                          📍 {t.zona_name || 'Sin Zona'}
                        </span>
                      </td>
                      <td>
                        <span className={`plate-mode ${t.plate_assignment_mode}`}>
                          {t.plate_assignment_mode === 'automatico' ? '🤖 Automático' : '👤 Manual'}
                        </span>
                      </td>
                      <td>
                        <span className={`status ${t.status}`}>
                          {t.status}
                        </span>
                      </td>
                      <td>
                        {t.novedad_actual ? (
                          <span style={{ background: '#fef3c7', color: '#b45309', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>
                            ⚠️ {t.novedad_actual}
                          </span>
                        ) : (
                          <span style={{ color: '#94a3b8', fontSize: '12px' }}>Ninguna</span>
                        )}
                      </td>
                      <td className="actions">
                        <button 
                          onClick={() => handleOpenModal(t)} 
                          className="btn-action btn-edit"
                          title="Editar Tránsito"
                        >
                          ✏️ Editar
                        </button>
                        <button 
                          onClick={() => handleToggleStatus(t)} 
                          className={`btn-action`}
                          style={{
                            background: t.status === 'activo' ? '#fee2e2' : '#dcfce7',
                            color: t.status === 'activo' ? '#b91c1c' : '#15803d',
                            border: '1px solid ' + (t.status === 'activo' ? '#f87171' : '#4ade80'),
                            marginLeft: '5px'
                          }}
                          title={t.status === 'activo' ? 'Deshabilitar Tránsito' : 'Habilitar Tránsito'}
                        >
                          {t.status === 'activo' ? '🚫 Deshabilitar' : '✅ Habilitar'}
                        </button>
                        <button 
                          onClick={() => handleOpenNovedadModal(t)} 
                          className="btn-action"
                          style={{
                            background: '#fef3c7',
                            color: '#b45309',
                            border: '1px solid #f59e0b',
                            marginLeft: '5px'
                          }}
                          title="Reportar / Editar Novedad Actual"
                        >
                          📢 Novedades
                        </button>
                        <button 
                          onClick={() => {
                            setSelectedTransitoForHistorial(t);
                            setShowHistorialModal(true);
                          }} 
                          className="btn-action"
                          style={{
                            background: '#e0f2fe',
                            color: '#0369a1',
                            border: '1px solid #7dd3fc',
                            marginLeft: '5px'
                          }}
                          title="Ver Bitácora / Historial de Novedades de este tránsito"
                        >
                          📜 Bitácora
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
              
              <Pagination 
                currentPage={currentPage}
                totalItems={transitos.length}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleItemsPerPageChange}
              />
            </div>
          )}
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>{editingTransito ? 'Editar Tránsito' : 'Nuevo Tránsito'}</h3>
            <form onSubmit={handleSave}>
              <div className="form-group">
                <label>Nombre del Tránsito</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>NIT</label>
                <input
                  type="text"
                  name="nit"
                  value={formData.nit}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Dirección</label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Teléfono</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Zona a la que pertenece</label>
                <select name="zona_id" value={formData.zona_id} onChange={handleChange} required className="form-input">
                  <option value="">-- Seleccionar Zona --</option>
                  {zonas.map(z => (
                    <option key={z.id} value={z.id}>{z.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Modo de Asignación de Placas</label>
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="plate_assignment_mode"
                      value="automatico"
                      checked={formData.plate_assignment_mode === 'automatico'}
                      onChange={handleChange}
                    />
                    🤖 Automático (Siguiente disponible)
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="plate_assignment_mode"
                      value="manual"
                      checked={formData.plate_assignment_mode === 'manual'}
                      onChange={handleChange}
                    />
                    👤 Manual (Escoger de la lista)
                  </label>
                </div>
              </div>

              {editingTransito && (
                <div className="form-group">
                  <label>Estado</label>
                  <select name="status" value={formData.status} onChange={handleChange}>
                    <option value="activo">Activo</option>
                    <option value="inactivo">Inactivo</option>
                  </select>
                </div>
              )}
              <div className="modal-actions">
                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary">
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  {editingTransito ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de Novedades */}
      {showNovedadModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '400px' }}>
            <h3 style={{ marginTop: 0 }}>📢 Reportar Novedad</h3>
            <p style={{ color: '#475569', fontSize: '13px', marginBottom: '15px' }}>
              Transito: <strong>{transitoForNovedad?.name}</strong>
            </p>
            <form onSubmit={handleSaveNovedad}>
              <div className="form-group">
                <label>Mensaje de Novedad (ej: RUNT caído)</label>
                <textarea
                  value={novedadText}
                  onChange={(e) => setNovedadText(e.target.value)}
                  placeholder="Escribe la novedad. Déjalo en blanco para quitar la alerta actual."
                  rows="3"
                  className="form-input"
                  style={{ width: '100%', resize: 'none' }}
                ></textarea>
              </div>
              <div className="modal-actions">
                <button type="button" onClick={() => setShowNovedadModal(false)} className="btn-secondary">
                  Cancelar
                </button>
                <button type="submit" className="btn-primary" style={{ background: '#d97706', border: 'none' }}>
                  Guardar Novedad
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de Historial / Bitácora de Novedades del Tránsito */}
      <HistorialNovedadesTransitoModal
        isOpen={showHistorialModal}
        onClose={() => {
          setShowHistorialModal(false);
          setSelectedTransitoForHistorial(null);
        }}
        transitoId={selectedTransitoForHistorial?.id}
        transitoName={selectedTransitoForHistorial?.name}
        transitosList={transitos}
      />
    </div>
  );
};

export default Transitos;
